function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M317.984,159.446c0-34.19-27.815-62.006-62.005-62.006s-62.006,27.815-62.006,62.006s27.816,62.006,62.006,62.006   S317.984,193.637,317.984,159.446z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.553,398.727c-9.075-3.243-19.115-5.995-29.851-8.245c-32.363,38.505-59.41,65.169-62.232,67.929L256,468.655   l-10.49-10.224c-2.826-2.754-29.951-29.39-62.381-67.905c-10.657,2.241-20.625,4.978-29.641,8.199   c-41.6,14.866-50.332,34.832-50.332,48.963s8.732,34.097,50.332,48.963c27.618,9.87,64.032,15.306,102.533,15.306   s74.915-5.436,102.533-15.306c41.599-14.866,50.331-34.832,50.331-48.963S400.152,413.593,358.553,398.727z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M332.544,337.733c55.548-72.281,84.909-133.231,84.909-176.26C417.453,72.437,345.016,0,255.979,0   C166.942,0,94.505,72.437,94.505,161.474c0,43.364,29.434,104.498,85.12,176.79c30.295,39.33,60.813,72.044,76.333,88.069   C271.523,410.203,302.2,377.217,332.544,337.733z M163.973,159.446c0-50.732,41.273-92.006,92.006-92.006   c50.732,0,92.005,41.273,92.005,92.006s-41.273,92.006-92.005,92.006C205.247,251.452,163.973,210.179,163.973,159.446z"
}));

var SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19px",
  height: "30px",
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 511.958 511.958",
  xmlSpace: "preserve"
}, props), _ref);

export default __webpack_public_path__ + "static/media/location.19afc75e.svg";
export { SvgLocation as ReactComponent };